import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Apiservice } from './api.service';
import { ButtonForm, costantValue } from './forms-template.service';
import { ActivatedRoute } from '@angular/router';

export interface ButtonToolbarForm {
  name: string;
  icon: string;
  text?: string;
  displayMode: string;
  hint: string;
  event: string;
  location: string;
  visible: boolean;
  disabled: boolean;
  queryString?: string,
  costantValue?: costantValue[];
  path: string;
  api: string;
  service: string;
  templateComponent: string;
  componentName: string;
  wPopUp?: any;
  hPopUp?: any;
  buttonSettings?: any




}[]

@Injectable({
  providedIn: 'root'
})



export class AnagraficaService {

  constructor(private Apiservice: Apiservice, private httpClient: HttpClient, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams
      .subscribe(params => {

        console.warn(params);


        if (params.service == 'sede') {

          let path = JSON.parse(params.filter);



          if (path['nsAzienda'] == true)
            soggetto[0].path = 'main/anagrafica-unita-locali-ns';
          else
            soggetto[0].path = 'main/anagrafica-unita-locali';


        }

      });
  }

  getElenco($subjectCalled, filterKey = '', filter = '', theQueryString = '', wingap = true) {

    let filterString = filter != '' ? filter : '';
    let pathFilter = filterKey != '' ? '/' + filterKey : '';

    /*  if(pathFilter.includes('/?')){
       pathFilter.replace('/?','?')
     } */


    let queryString = theQueryString != '' ? theQueryString : '';
    let completeString = '';

    if (pathFilter != '' && queryString != '' && filterString != '') {

      completeString = pathFilter + queryString + '&' + filterString + '&'

    }


    let EndPoint = ''

    if (completeString != '') {
      if (wingap === true) {
        EndPoint = environment.BASE_API_URL + completeString;
      } else {
        EndPoint = environment.BASE_API_URL_APIREST + completeString;
      }
    } else {
      if (wingap === true) {
        EndPoint = environment.BASE_API_URL + $subjectCalled + pathFilter + filterString + queryString;
      } else {
        EndPoint = environment.BASE_API_URL_APIREST + $subjectCalled + pathFilter + filterString + queryString;
      }
    }

    ////console.log(parthFilter + 'filterkey: ' + filterKey)
    //console.log('enPoint: ' + EndPoint)

    const HeaderOdata = this.Apiservice.httpOptionCall();


    EndPoint = EndPoint.replace('=?', '=');
    EndPoint = EndPoint.replace('$filter=$filter=', '$filter=');
    EndPoint = EndPoint.replace('$filter=?$filter=', '$filter=');
    EndPoint = EndPoint.replace('??', '?');

    const response = this.httpClient.get(EndPoint, HeaderOdata).toPromise();
    pathFilter = '';
    queryString = '';
    filterString = ''
    return response;
  }

  getValue(subjectCalled, filterKey: any, queryString, api_rest = false) {

    let filterPath = ''
    if (typeof filterKey != 'undefined') {
      filterPath = filterKey;
    }

    //console.log('filterKey', filterPath)

    let query = queryString ? queryString : ''

    let completeDataSource

    if (subjectCalled.includes('?') || subjectCalled.includes('/')) {
      const arrConslash = subjectCalled.split('/')
      if (arrConslash.length > 1) {
        // arrConslash[arrConslash.length - 1] + '/' + filterPath
        completeDataSource = arrConslash.join('/')
      } else {
        completeDataSource = subjectCalled + filterPath
      }
    } else {
      if (String(filterKey).includes('/') || String(filterKey).includes('?') && filterPath) {
        completeDataSource = subjectCalled + filterPath
      } else {
        if (filterPath) {
          completeDataSource = subjectCalled + '/' + filterPath
        } else {
          completeDataSource = subjectCalled
        }
      }


    }
    let EndPoint = '';
    if (!api_rest)
      EndPoint = environment.BASE_API_URL + completeDataSource + query
    else
      EndPoint = environment.BASE_API_URL_APIREST + completeDataSource + query



    //console.log(EndPoint)
    const HeaderOdata = this.Apiservice.httpOptionCall();

    const response = this.httpClient.get(EndPoint, HeaderOdata).toPromise();

    return response;
  }

  async actionPut($subjectCalled, data, isKeyid = true, api_rest = false, masterKey = 'id') {

    const keyId = !isKeyid ? '' : '/' + data[masterKey]

    var EndPoint = ''
    if (!api_rest)
      EndPoint = environment.BASE_API_URL + $subjectCalled + keyId;
    else
      EndPoint = environment.BASE_API_URL_APIREST + $subjectCalled + keyId;

    const HeaderOdata = this.Apiservice.httpOptionCall();

    const response = await this.httpClient.put(EndPoint, data, HeaderOdata).toPromise();

    ////console.log(response); 

    return response



  }

  actionInsert($subjectCalled, data, test = false) {
    let EndPointT
    if (test) {
      EndPointT = environment.BASE_API_URL_APIREST
    } else {
      EndPointT = environment.BASE_API_URL
    }
    const EndPoint = EndPointT + $subjectCalled;
    //console.log(data)
    const HeaderOdata = this.Apiservice.httpOptionCall();

    const response = this.httpClient.post(EndPoint, data, HeaderOdata).toPromise();
    return response;
  }

  actionDelete(subjectCalled, dataRefer) {
    const EndPoint = environment.BASE_API_URL + subjectCalled + '/' + dataRefer;;
    const HeaderOdata = this.Apiservice.httpOptionCall();
    const response = this.httpClient.delete(EndPoint, HeaderOdata).toPromise();
    return response;
  }

  getService(subjectCalled) {
    if (subjectCalled == 'schedeRifiuti') {
      return schedeRifiuti;
    }
    if (subjectCalled == 'soggetto') {
      return soggetto
    }
    if (subjectCalled == 'sede') {
      return sede
    }
    if (subjectCalled == 'magazzino') {
      return magazzino
    }
    /*
    if (subjectCalled == 'cantiere') {
      return magazzino
    }
    */
    if (subjectCalled == 'automezzo') {
      return magazzino
    }
    if (subjectCalled == 'alboCategoria') {
      return alboCategoria
    }
    if (subjectCalled == 'autorizzazione') {
      return autorizzazione
    }
    if (subjectCalled == 'autista') {
      //return magazzino
    }
    if (subjectCalled == 'generalToolbar') {
      return generalToolbar
    }
    if (subjectCalled == 'movimentiToolbar') {
      return movimentiToolbar
    }
    if (subjectCalled == 'cantiere') {
      return cantiere;
    }


  }



}
let alboCategoria: ButtonToolbarForm[] = [
  {
    name: 'Allegati',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    queryString: '?NomeTabella=categoriealbo&idTabella=$id',
    costantValue: [
      { key: 'nomeTabella', value: 'categoriealbo' },
      { key: 'nomeTabellaPadre', value: 'sedi' },
      { key: 'idTabella', value: 'id' },
      { key: 'idTabellaPadre', value: 'idSede' }
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502",
    buttonSettings: {
      displayButtons:
      {


        typeOfConditions: '',
        arrayCondition: [
          { key: 'id', value: 0, operator: '>', }

        ],


      },


    }
  },


]


let movimentiToolbar: ButtonToolbarForm[] = [

  {
    name: 'Allegati',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    costantValue: [
      { key: 'nomeTabella', value: 'soggetti' },
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502",
    buttonSettings: {


      displayButtons:
      {


        typeOfConditions: '',
        arrayCondition: [
          { key: 'id', value: 0, operator: '>', }

        ],


      },


    }
  },


  {
    name: 'Stampa',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'stampa',
    api: 'stampa',
    path: '',
    templateComponent: '',
    componentName: 'GrigliaModelliComponent',
    costantValue: [
      { key: 'nomeTabella', value: 'movimenti' }
    ],
    hint: 'Stampa con modello predefinito',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "700",
    buttonSettings: {


      displayButtons:
      {


        typeOfConditions: '&&',
        arrayCondition: [
          { key: 'tipoFormulario', value: 'V', operator: '==', },
          { key: 'isEdit', value: true, operator: '==', }

        ],


      },


    }
  },








  /* {
    name: 'Utility',
    icon: 'glyphicon mdi mdi-settings-outline',
    displayMode: 'in-line',
    hint: 'Utility',
    event: '2',
    templateComponent: 'popup',
    location: 'bottom',
    componentName: 'AnagraficaUtilityComponent',
    service: '',
    api: '',
    path: '',
    disabled: false,
    visible: true
  }, */

]


let generalToolbar: any[] = [


  { name: 'Chiudi', icon: 'glyphicon icon-exit', displayMode: 'in-line', value: 'main', dataSource: '', costantValue: [{ key: 'close', value: true }], hint: 'Chiudi anagrafica', event: '5', location: 'top', visible: true },

  /* { name: 'Utility', icon: 'glyphicon mdi mdi-settings-outline', displayMode: 'in-line', hint: 'Utility', event: '2', value: 'popup', location: 'bottom', dataSource: 'AnagraficaUtilityComponent', visible: true },
 */
]


let soggetto: ButtonToolbarForm[] = [

  {
    name: 'Unità Locali',
    icon: 'glyphicon icon-home-elenco-soggetti',
    displayMode: 'in-line',
    service: 'sede',
    api: 'sede',
    templateComponent: 'grid',
    hint: 'Lista Unità Locali',
    event: '3',
    location: 'top',
    visible: true,
    disabled: false,
    componentName: 'AnaUnitaLocaliComponent',
    path: 'main/anagrafica-unita-locali-ns',
  },
  /* {
    name: 'R.E.N.T.R.i',
    icon: 'glyphicon icon-icona-app-rentri',
    displayMode: 'in-line',
    path: 'main/rentri',
    service: 'sede',
    api: 'sede',
    templateComponent: 'grid',
    componentName: 'RentriComponent',
    costantValue: [{ key: 'idSoggetto', value: 'id' }],
    visible: true,
    disabled: false,
    hint: 'Piattaforma R.E.N.T.R.i',
    event: '4',
    location: 'top',
    buttonSettings: {


      displayButtons:
      {


        typeOfConditions: '&&',
        arrayCondition: [
          { key: 'nsAzienda', value: true, operator: '==', },
          { key: 'isConfigRentri', value: true, operator: '==', }

        ],


      },


    }

  },
  {
    name: 'Gestione ViviFir',
    icon: 'glyphicon icon-icona-vivifir',
    displayMode: 'in-line',
    path: 'main/vivifir',
    componentName: 'VivifirComponent',
    templateComponent: 'form',
    service: 'sede',
    api: 'sede',
    visible: true,
    disabled: false,
    hint: 'Gestione ViviFir',
    costantValue: [
      { key: 'CODFIS', value: 'codiceFiscale' },
      { key: 'idSoggetto', value: 'id', },
      { key: 'descSoggetto', value: 'ragioneSociale' }
    ],
    event: '4',
    location: 'top',
    buttonSettings: {


      displayButtons:
      {


        typeOfConditions: '&&',
        arrayCondition: [
          { key: 'nsAzienda', value: true, operator: '==', },
          { key: 'isConfigVivifir', value: true, operator: '==', }

        ],


      },


    }

  }, */

  {
    name: 'Contatti',
    icon: 'glyphicon icon-contatti-form',
    displayMode: 'in-line',
    api: 'contatti',
    service: 'contatti',
    path: '',
    templateComponent: '', //grid
    componentName: 'ContattiComponent',
    hint: 'Lista Contatti',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000", //1500
    hPopUp: "800",
    costantValue: [
      { key: 'nomeTabella', value: 'soggetti' },
      { key: 'idTabella', value: 'id' }
    ],
  },
  {

    name: 'Allegati',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    queryString: '/getAllByDatiPadre?nomeTabellaPadre=soggetti&idTabellaPadre=$id',
    costantValue: [
      { key: 'nomeTabella', value: 'soggetti' }, //Se mi trovo in documenti generali (sedi e soggetti) allora passo solo questi parametri
      { key: 'idTabella', value: 'id' }
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502"
  },

  /* {
    name: 'Utility',
    icon: 'glyphicon mdi mdi-settings-outline',
    displayMode: 'in-line',
    hint: 'Utility',
    event: '2',
    templateComponent: 'popup',
    location: 'bottom',
    componentName: 'AnagraficaUtilityComponent',
    service: '',
    api: '',
    path: '',
    disabled: false,
    visible: true
  }, */

]

let schedeRifiuti: ButtonToolbarForm[] = [

  {
    name: 'Analisi',
    text: 'Allega Analisi',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    queryString: '?NomeTabella=SCHEDARIFIUTO_ANALISI&idTabella=$id',
    costantValue: [
      { key: 'nomeTabella', value: 'SCHEDARIFIUTO_ANALISI' },
      { key: 'idTabella', value: 'id' }
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502"
  },
  {
    name: 'Sicurezza',
    text: 'Allega Sicurezza',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    templateComponent: '',

    componentName: 'AllegatiComponent',
    queryString: '?NomeTabella=SCHEDARIFIUTO_SICUREZZA&idTabella=$id',
    costantValue: [
      { key: 'nomeTabella', value: 'SCHEDARIFIUTO_SICUREZZA' },
      { key: 'idTabella', value: 'id' }
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502"
  }, {
    name: 'Foto',
    text: 'Allegati Foto',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    queryString: '?NomeTabella=SCHEDARIFIUTO_FOTO&idTabella=$id',
    costantValue: [
      { key: 'nomeTabella', value: 'SCHEDARIFIUTO_FOTO' },
      { key: 'idTabella', value: 'id' }
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502"
  },
  {
    name: 'Campionamenti',
    text: 'Campionamenti',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    queryString: '?NomeTabella=SCHEDARIFIUTO_CAMPIONAMENTI&idTabella=$id',
    costantValue: [
      { key: 'nomeTabella', value: 'SCHEDARIFIUTO_CAMPIONAMENTI' },
      { key: 'idTabella', value: 'id' }
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502"
  }, {
    name: 'Omologa',
    text: 'Allega Omologa',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    queryString: '?NomeTabella=SCHEDARIFIUTO_OMOLOGA&idTabella=$id',
    costantValue: [
      { key: 'nomeTabella', value: 'SCHEDARIFIUTO_OMOLOGA' },
      { key: 'idTabella', value: 'id' }
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502"
  }

]

let sede: ButtonToolbarForm[] = [
  /* {
    name: 'Elenco aziende',
    icon: 'glyphicon icon-annulla-form',
    displayMode: 'in-line',
    templateComponent: 'grid',
    hint: 'Lista anagrafica aziende',
    event: '4',
    location: 'top',
    visible: true,
    disabled: false,
    componentName: 'AnaSoggettoComponent',
    path: 'main/anagrafiche-propri-impianti',
    service: 'soggetto',
    api: 'soggetto',
    costantValue: [
      { key: 'nostraAzienda', value: 'nostraAzienda' }
    ],

  }, */
  /* {
    name: 'Unità Locali',
    icon: 'glyphicon icon-home-elenco-soggetti',
    displayMode: 'in-line',
    templateComponent: 'grid',
    hint: 'Lista Unità Locali',
    event: '3',
    location: 'top',
    componentName: 'AnaUnitaLocaliComponent',
    path: 'main/anagrafica-unita-locali',
    service: 'sede',
    api: 'sede',
    visible: true,
    disabled: false,
  }, */
  {
    name: 'Magazzini Rifiuti',
    icon: 'glyphicon icon-magazzino-form',
    hint: 'Lista Magazzini',
    event: '3',
    location: 'top',
    displayMode: 'in-line',
    service: 'magazzinorifiuti',
    api: 'magazzinorifiuti',
    componentName: 'AnaMagazziniComponent',
    path: 'main/anagrafica-magazzini',
    templateComponent: 'grid',
    visible: true,
    disabled: false,
    buttonSettings: {


      displayButtons:
      {


        typeOfConditions: '&&',
        arrayCondition: [
          { key: 'nsAzienda', value: true, operator: '==', },
          { key: 'isProduttore', value: true, operator: '==', }

        ],


      },


    }

  },
  {
    name: 'Cantieri esterni',
    icon: 'glyphicon icon-cantieri-esterni-form',
    hint: 'Lista cantieri',
    event: '3',
    location: 'top',
    displayMode: 'in-line',
    service: 'cantiere',
    api: 'cantiere',
    templateComponent: 'grid',
    componentName: 'AnaCantieriComponent',
    path: 'main/anagrafica-cantieri',
    visible: true,
    disabled: false,
    buttonSettings: {


      displayButtons:
      {


        typeOfConditions: '&&',
        arrayCondition: [
          { key: 'isProduttore', value: true, operator: '==', },
          { key: 'nsAzienda', value: true, operator: '==', },


        ],


      },


    }

  },

  {
    name: 'Categorie Albo',
    icon: 'glyphicon icon-iscrizione-albo-form',
    hint: 'categorie albo',
    event: '3',
    location: 'top',
    displayMode: 'in-line',
    //service: 'albo',
    //api: 'albo',
    //path: 'main/anagrafica-albo', //main/anagrafica-albo
    //componentName: 'AnaAlboComponent',

    path: 'main/anagrafica-albo',
    componentName: 'AnaAlboComponent',
    service: 'AlboCategoria',
    api: 'AlboCategoria',


    templateComponent: 'grid',
    visible: true,
    disabled: false,
    buttonSettings: {


      displayButtons:
      {
        typeOfConditions: '',
        arrayCondition: [

          { key: 'numeroIscrizioneAlbo', value: null, operator: '!=' }
        ],


      },


    }
  },




  {
    name: 'Automezzi',
    icon: 'glyphicon icon-automezzi-form',
    hint: 'Lista automezzi',
    event: '3',
    location: 'top',
    displayMode: 'in-line',
    service: 'automezzo',
    api: 'Automezzo',
    path: 'main/anagrafica-automezzo',
    componentName: 'AnaAutomezzoComponent',
    templateComponent: 'grid',
    visible: true,
    disabled: false,
    buttonSettings: {


      displayButtons:
      {


        typeOfConditions: '',
        arrayCondition: [
          { key: 'isTrasportatore', value: true, operator: '==', },


        ],


      },


    }
    /*  items: [
       {
         dataSource: 'AlboAutomezzo', name: 'Cat. automezzo', icon: 'glyphicon icon-categoria-albo-gestore', displayMode: 'in-line', value: 'grid', costantValue: 'id', hint: 'Categorie Autorizzate', event: '3', location: 'top',
         
       },
     ] */
  },
  {
    name: 'Autisti',
    icon: 'glyphicon icon-autisti',
    hint: 'Lista Autisti',
    location: 'top',
    event: '3',
    displayMode: 'in-line',
    service: 'autista',
    api: 'autista',
    componentName: 'AnaAutistiComponent',
    path: 'main/anagrafica-autisti',
    templateComponent: 'grid',
    visible: true,
    disabled: false,
    buttonSettings: {


      displayButtons:
      {


        typeOfConditions: '',
        arrayCondition: [
          { key: 'isTrasportatore', value: true, operator: '==', },


        ],


      },


    }
  },
  {
    name: 'Lotti',
    icon: 'glyphicon icon-lotti-produzione',
    hint: 'Lista Lotti',
    event: '3',
    location: 'top',
    displayMode: 'in-line',
    service: 'lotto',
    api: 'lotto',
    templateComponent: 'grid',
    componentName: 'AnaLottiComponent',
    path: 'main/anagrafica-lotti',
    visible: true,
    disabled: false,
    buttonSettings: {


      displayButtons:
      {


        typeOfConditions: '&&',
        arrayCondition: [
          { key: 'isProduttore', value: true, operator: '==', },
          { key: 'nsAzienda', value: true, operator: '==', },


        ],


      },


    }

  },
  {
    name: 'Autorizzazioni',
    icon: 'glyphicon icon-autorizzazioni-form',
    hint: 'Lista Autorizzazioni',
    event: '3',
    location: 'top',
    displayMode: 'in-line',
    path: 'main/anagrafica-autorizzazione',
    componentName: 'AnaAutorizzazioneComponent',
    service: 'autorizzazione',
    api: 'autorizzazione',
    templateComponent: 'grid',
    visible: true,
    disabled: false,
    buttonSettings: {

      displayButtons:
      {

        typeOfConditions: '||',
        arrayCondition: [
          { key: 'isSmaltitore', value: true, operator: '==', },

          { key: 'isProduttore', value: true, operator: '==', },

        ],

      },


    }
  },
  /* { name: 'R.E.N.T.R.i', icon: 'glyphicon icon-icona-app-rentri', displayMode: 'in-line', value: 'main/rentri', dataSource: 'RentriComponent', costantValue: [{ key: 'idSoggetto', value: 'idSoggetto' }], hint: 'Piattaforma R.E.N.T.R.i', event: '4', location: 'top' }, */
  /*  { name: 'Gestione ViviFir', icon: 'glyphicon icon-icona-vivifir', displayMode: 'in-line', value: 'main/vivifir', dataSource: 'VivifirComponent', hint: 'Gestione ViviFir', costantValue: [{ key: 'idSoggetto', value: 'idSoggetto' }, { key: 'CODFIS', value: 'codiceFiscale', }, { key: 'descSoggetto', value: 'descrizioneSoggetto' }], event: '4', location: 'top' }, */
  {
    name: 'Contatti',
    icon: 'glyphicon icon-contatti-form',
    displayMode: 'in-line',
    api: 'contatti',
    service: 'contatti',

    templateComponent: 'grid',
    componentName: 'ContattiComponent',
    path: 'main/contatti',
    queryString: '?nomeTabella=contatti&idTabella=$id',
    costantValue: [
      { key: 'nomeTabella', value: 'sedi' },
      { key: 'idTabella', value: 'id' }
    ],

    hint: 'Lista Contatti',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "800"
  },
  {
    name: 'Allegati',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    queryString: '/getAllByDatiPadre?nomeTabellaPadre=sedi&idTabellaPadre=$id',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    costantValue: [
      { key: 'nomeTabella', value: 'sedi' }, //Se mi trovo in documenti generali (sedi e soggetti) allora passo solo questi parametri
      { key: 'idTabella', value: 'id' }
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502"
  },

  /* {
    name: 'Utility',
    icon: 'glyphicon mdi mdi-settings-outline',
    displayMode: 'in-line',
    hint: 'Utility',
    event: '2',
    templateComponent: 'popup',
    location: 'bottom',
    componentName: 'AnagraficaUtilityComponent',
    service: '',
    api: '',
    path: '',
    disabled: false,
    visible: true
  }, */

]

let magazzino: ButtonToolbarForm[] = [
  {
    name: 'Contatti',
    icon: 'glyphicon icon-contatti-form',
    displayMode: 'in-line',
    api: 'contatti',
    service: 'contatti',
    path: '',
    templateComponent: 'grid',
    componentName: 'ContattiComponent',
    hint: 'Lista Contatti',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    costantValue: [
      { key: 'nomeTabella', value: 'soggetti' }
    ],
    wPopUp: "1000",
    hPopUp: "800"
  },
  /*
  {
  
    name: 'Documenti',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    costantValue: [
      { key: 'nomeTabella', value: 'magazzini' }
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502"
  },
  */
  /*  {
     name: 'Utility',
     icon: 'glyphicon mdi mdi-settings-outline',
     displayMode: 'in-line',
     hint: 'Utility',
     event: '2',
     templateComponent: 'popup',
     location: 'bottom',
     componentName: 'AnagraficaUtilityComponent',
     service: '',
     api: '',
     path: '',
     disabled: false,
     visible: true
   }, */
]


let cantiere: ButtonToolbarForm[] = [

  {

    name: 'Allegati',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegato',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    queryString: '?NomeTabella=cantieri&idTabella=$id',
    costantValue: [
      { key: 'nomeTabella', value: 'cantieri' },
      { key: 'nomeTabellaPadre', value: 'sedi' },
      { key: 'idTabella', value: 'id' },
      { key: 'idTabellaPadre', value: 'idSede' }
    ],
    /*    { key: 'dataRilascio', value: 'dataRilascio' }, */
    hint: "Lista allegati del cantiere",
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502",
    buttonSettings: {

      displayButtons:
      {

        typeOfConditions: '',
        arrayCondition: [
          { key: 'id', value: 0, operator: '>', }

        ],


      },


    }
  },
]

let autorizzazione: ButtonToolbarForm[] = [

  {

    name: 'Allegati',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegato',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    queryString: '?NomeTabella=autorizzazioni&idTabella=$id',
    costantValue: [
      { key: 'nomeTabella', value: 'autorizzazioni' },
      { key: 'nomeTabellaPadre', value: 'sedi' },
      { key: 'idTabella', value: 'id' },
      { key: 'idTabellaPadre', value: 'idSede' }
    ],
    /*    { key: 'dataRilascio', value: 'dataRilascio' }, */
    hint: "Lista allegati dell'autorizzazione corrente",
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "502",
    buttonSettings: {

      displayButtons:
      {

        typeOfConditions: '',
        arrayCondition: [
          { key: 'id', value: 0, operator: '>', }

        ],


      },


    }
  },

]